import React from "react";
import RevenueReport from "./RevenueReport";

const DeferredRevenue: React.FC = () => {
  return (
    <RevenueReport revenueType="deferred"></RevenueReport>
  )
}

export default DeferredRevenue;